import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const chatErrorFn = /* @__PURE__ */ createRecipe('chatError', {}, [])

const chatErrorVariantMap = {}

const chatErrorVariantKeys = Object.keys(chatErrorVariantMap)

export const chatError = /* @__PURE__ */ Object.assign(memo(chatErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'chatError',
  __getCompoundVariantCss__: chatErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: chatErrorVariantKeys,
  variantMap: chatErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, chatErrorVariantKeys)
  },
  getVariantProps: chatErrorFn.getVariantProps,
})